import data from '../../data.json'
// import Card from '../../modules/Cards/Card'
import FlashCard from '../../modules/FlashCard/FlashCard'
import Card from '../../modules/Cards/Card'
import './Main.scss'
import MainBtn from '../../modules/Button/MainBtn'
import MiniForm from '../../modules/ContactForm/MiniForm'
import TeacherModul from '../../modules/TeacherCard/TeacherModule'
import FullAccordeon from '../../modules/Accordeon/FullAccorgeon'
import ReviewsBlock from '../../modules/Reviews/ReviewsBlock'

import { Helmet } from 'react-helmet';
import Popup from '../../modules/Popup/Popup'

export default function Main(){

    return(
        <div className="Main">
             <Helmet>
                    <title>Академія SmartumPro</title>
                    <meta name="description" content="Академія розвитку інтелекту SmartumPro для дітей від 5 до 16 років. Ментальна арифметика, розвиток читання, англійська мова, ліберика, меморика, таблиця множення, підготовка до школи, математика, гармонійний розвиток півкуль, розвиток пам'яті." />
                   
                    {/* Соціальні прев'ю (опціонально) */}
                    <meta property="og:title" content="Головна - Академія SmartumPro" />
                    <meta property="og:description" content="Академія розвитку інтелекту SmartumPro для дітей від 5 до 16 років. Ментальна арифметика, розвиток читання, англійська мова, ліберика, меморика, таблиця множення, підготовка до школи, математика, гармонійний розвиток півкуль, розвиток пам'яті." />
                    <meta property="og:image" content="https://your-domain.com/img/preview.jpg" />
                    <meta property="og:url" content="https://smartum-pro.com/" />
                   
                  </Helmet>
            <div className="wrapper">
                <div className="offer">
                    <div className="offer_img">
                        <img src="./main4.avif" alt="offer-img" loading="eager" decoding="async" />
                    </div>
                    <div className="offer_body">
                        <h1 className='offer_text'>SMARTUM - місце де діти вчаться із задоволенням.</h1>
                        <p>Приєднуйтесь! Перше заняття - безкоштовне.</p>
                        <MainBtn text={' Пробне заняття'} />
                    </div>
                   
                </div>
                <div className="courses">
                    <h2 className='title'>Наші курси</h2>
                    <div className='couses_list'>
                        {data.map((card) => {
                            return <FlashCard key={card.path} title={card.name} img={card.course_icon} color={card.color} age={card.age} path={card.path} />
                           
                        })}
                    </div>

                    <div className="bonus-btn">
                        <MainBtn text={"Спробувати безкоштовно"} />
                    </div>

                    
                    

                </div>
                
                

                <div className="about-us">
                    <div className="about_img">
                        <img src="./c5.png" alt="girl" />
                    </div>
                    <div className="about_body">
                        <h2 className='title'>Smartum це:</h2>
                        <ul>
                            <li>👤 Індивідуальний підхід до кожного учня</li>
                            <li>💻 Інноваційна онлайн-платформа</li>
                            <li>🧩 Більше 100 розвиваючих ігор</li>
                            <li>📖 Навчальна програма та навчальні матеріали</li>
                            <li>🎓 Моніторинг успішності студентів</li>
                        </ul>
                    </div>
                </div>

                <div className="format">
                    <h2 className='title'>В якому форматі ми працюємо?</h2>
                    
                    <div className="format_cards">

                        <Card title={'Online'} img={'https://thumbs.dreamstime.com/b/cartoon-girl-sitting-desk-laptop-front-her-ai-generated-image-cartoon-girl-sitting-desk-320199680.jpg'} about={'Онлайн заняття проходять через зум з використанням нашої платформи'} />
                                           
                        <Card title={'Offline'} img={'https://thumbs.dreamstime.com/b/holstentor-building-shown-cartoon-as-backdrop-happy-school-children-330041878.jpg'} about={'Заняття проходять в наших центрах в м.Ізмаїл та Білгород-Дністровський '} />
                    </div>
                    
                </div>

                <div className="contact-form">
                    <img src="./wave2.svg" alt="" />
                    <div className="form_body">
                        <div className="form_text">
                            <h2>Відвідайте безкоштовне заняття онлайн або офлайн у наших центрах</h2>
                        </div>
                        <div className="form_item">
                        <MiniForm />
                        </div>
                        
                    </div>
                </div>
                
                <div>
                    <h2 className='title'>Відгуки</h2>
                    <ReviewsBlock />
                </div>

                <div className="command">
                    <h2 className='title'>Наша команда</h2>
                    <TeacherModul />
                </div>

                <div className="questions">
                    <h2 className='title'>Найпоширеніші запитання</h2>
                    
                   <FullAccordeon />
                    
                
                </div>
            </div>

            <Popup />

        </div>
    )
}